import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Pagination, Navigation } from "swiper/modules";
import Category_Subcategory_Card from "../../common-components/category_subcategory_card/Category_Subcategory_Card";
import "./Home_Category_Section.css";
import { useNavigate } from "react-router-dom";

const Home_Category_Section = () => {
  const navigate = useNavigate();
  const category = useSelector((state) => state.master.categories);
  const [swiperInstance, setSwiperInstance] = useState(null);

  return (
    <section className="Home_Category_Section">
      <div className="container">
        <div className="category_list_div">
          <div className="heading_holder">
            <h4 className="heading_text">Category</h4>
          </div>

          <div className="cat_subcat_div">
            <div variant="pills" className="flex-row p-0 mb-3">
              <Swiper
                className="mySwiper "
                onSwiper={(swiper) => setSwiperInstance(swiper)}
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                }}
                modules={[Pagination, Navigation]}
                breakpoints={{
                  0: { slidesPerView: 2, spaceBetween: 5 },
                  320: { slidesPerView: 3, spaceBetween: 5 },
                  486: { slidesPerView: 3, spaceBetween: 10 },
                  576: { slidesPerView: 4, spaceBetween: 10 },
                  768: { slidesPerView: 5, spaceBetween: 10 },
                  992: { slidesPerView: 6, spaceBetween: 10 },
                  1200: { slidesPerView: 8, spaceBetween: 10 },
                }}
              >
                {category?.map((slide, index) => (
                  <SwiperSlide key={index} className="product-slide">
                    <Nav.Item>
                      <Nav.Link eventKey={slide?.id} onClick={() =>
                            navigate(`/categories?category_id=${slide?.id}`)
                          }>
                        <Category_Subcategory_Card
                          className="product-image"
                          content={slide?.name}
                          image={process.env.REACT_APP_IMG_URL + slide?.image}
                          imgClassName="category-image"
                          
                        />
                        <div className="triangle-right"></div>
                      </Nav.Link>
                    </Nav.Item>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home_Category_Section;
